/**
 * <facet-pill-bar>
 *
 * Mobile filter pill bar. Each pill button has a data-pill-target attribute
 * pointing to the id of its dropdown panel (sibling under the same
 * <facet-pill-bar>). Clicking a pill toggles the corresponding dropdown,
 * closing any other open dropdown. Escape and outside-click close.
 */
class FacetPillBar extends HTMLElement {
  connectedCallback() {
    this.boundClick = this._onClick.bind(this);
    this.boundEscape = this._onEscape.bind(this);
    this.boundOutside = this._onOutside.bind(this);
    this.addEventListener('click', this.boundClick);
    document.addEventListener('keydown', this.boundEscape);
    document.addEventListener('click', this.boundOutside);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClick);
    document.removeEventListener('keydown', this.boundEscape);
    document.removeEventListener('click', this.boundOutside);
  }

  _onClick(event) {
    const pill = event.target.closest('.cf2-pill[data-pill-target]');
    if (!pill || !this.contains(pill)) return;
    event.preventDefault();
    const targetId = pill.dataset.pillTarget;
    const dropdown = this.querySelector('#' + CSS.escape(targetId));
    if (!dropdown) return;
    const isOpen = !dropdown.hasAttribute('hidden');
    this._closeAll();
    if (!isOpen) {
      dropdown.removeAttribute('hidden');
      pill.setAttribute('aria-expanded', 'true');
    }
  }

  _onEscape(event) {
    if (event.key !== 'Escape') return;
    const openPanel = this.querySelector('.cf2-pill-dropdown:not([hidden])');
    if (!openPanel) return;
    this._closeAll();
    const triggerPill = this.querySelector('.cf2-pill[data-pill-target="' + openPanel.id + '"]');
    if (triggerPill) triggerPill.focus();
  }

  _onOutside(event) {
    if (this.contains(event.target)) return;
    this._closeAll();
  }

  _closeAll() {
    this.querySelectorAll('.cf2-pill-dropdown:not([hidden])').forEach((d) => d.setAttribute('hidden', ''));
    this.querySelectorAll('.cf2-pill[aria-expanded="true"]').forEach((p) => p.setAttribute('aria-expanded', 'false'));
  }
}

if (!window.customElements.get('facet-pill-bar')) {
  window.customElements.define('facet-pill-bar', FacetPillBar);
}
